import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  rootContent: {
    width: "100%",
    height: "calc(100vh - 101px)",
    overflowX: "hidden",
    background: theme.palette.common.white,
  },
}), {
  name: "admin-users-tab-styles",
  flip: null,
});

export default useStyles;
